export const LIVESTREAM_PLAY_STATES = {
    LIVE: 'live',
    LIVE_NEARLY_ENDING: 'live_nearly_ending',
    VOD: 'vod',
    WAITING_FOR_VOD: 'waiting_for_vod',
    NO_VOD: 'no_vod',
    COUNTER: 'counter',
    WAIT_FOR_MANUAL_START: 'wait_for_manual_start',
};

